module.exports = __webpack_public_path__ + "img/banner-rights.2eee994c.png";